/**
 * [web/shell] Selects public pages and the authenticated workbench.
 * Owns route-level loading; product pages and account state stay in their own modules.
 */
import { Suspense, lazy } from 'react';
import { useLocation } from 'react-router-dom';
import { isPublicSitePath } from './lib/site-navigation.ts';

const PublicSite = lazy(() => import('./routes/public/PublicSite.tsx').then(m => ({ default: m.PublicSite })));
const WorkspaceApp = lazy(() => import('./WorkspaceApp.tsx').then(m => ({ default: m.WorkspaceApp })));

export function App() {
  const location = useLocation();
  return (
    <Suspense fallback={<div className="empty" role="status">读取中…</div>}>
      {isPublicSitePath(location.pathname) ? <PublicSite /> : <WorkspaceApp />}
    </Suspense>
  );
}
